import { useEffect, useState } from "react";
import {
  fetchDeployedMainJsHash,
  getLoadedMainJsHash,
} from "../utils/appVersion";

const POLL_INTERVAL_MS = 5 * 60 * 1000;

export default function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      return undefined;
    }

    const loadedHash = getLoadedMainJsHash();
    if (!loadedHash) {
      return undefined;
    }

    let cancelled = false;

    async function checkForUpdate() {
      try {
        const deployedHash = await fetchDeployedMainJsHash();
        if (
          !cancelled &&
          deployedHash &&
          loadedHash &&
          deployedHash !== loadedHash
        ) {
          setUpdateAvailable(true);
        }
      } catch {
        // Ignore transient network errors; we'll retry on the next poll.
      }
    }

    function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        checkForUpdate();
      }
    }

    checkForUpdate();
    const intervalId = window.setInterval(checkForUpdate, POLL_INTERVAL_MS);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return { updateAvailable };
}
